/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { VM }                      from 'g3w-eventbus';
import ApplicationState            from 'store/application';
import GUI                         from 'services/gui';
import { XHR }                     from 'utils/XHR';
import { getCatalogLayerById }     from 'utils/getCatalogLayerById';

import CatalogChangeMapThemes      from 'components/CatalogChangeMapThemes.vue';
import CatalogTristateTree         from 'components/CatalogTristateTree.vue';

/**
 * Stringify a query URL param (eg. `&WIDTH=700`)
 *
 * @param name
 * @param value
 *
 * @returns { string | null } a string if value is set or null
 */
 function __(name, value) {
  return (value || 0 === value) ? `${name}${value}` : null;
}

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'catalog',

  data() {
    return {
      state:            this.$options.service.state || {},
      legend_position:  ApplicationState.project.state.legend_position || 'tab',
      iframe:           ApplicationState.iframe,
      showlegend:       false,
      backgroundLegend: ApplicationState.gui.layout.app.legend && ApplicationState.gui.layout.app.legend.transparent ? 'transparent' : '#FFFFFF', //@since 3.11.3 set transparent or white background
      currentBaseLayer: null,
      activeTab:        ApplicationState.project.state.catalog_tab || 'layers',
      loading:          false,
    }
  },

  components: {
    CatalogChangeMapThemes,
    CatalogTristateTree,
  },

  computed: {

    project() {
      return ApplicationState.project;
    },

    title() {
      return this.project.state.name;
    },

    baselayers() {
      return this.project.state.baselayers;
    },

    hasBaseLayers() {
      return this.project.state.baselayers.length > 0;
    },

    hasLayers() {
      return (
        this.state.external.vector.length > 0 //has external layers
        || this.state.layerstrees.reduce(( a , l ) => l.tree.length + a, 0) > 0
        || this.state.layersgroups.length > 0
      );
    },

    /**
     * @returns {boolean} whether it should list any related projects or maps.
     *
     * @since 3.8.0
     */
     hasRelatedMaps() {
      return window.initConfig.macrogroups.length + window.initConfig.groups.length + window.initConfig.projects.length > 1;
    },

  },

  methods: {

    onLegendError(url) {
      url.error   = true;
      url.loading = false;
    },

    onLegendLoad(url) {
      url.loading = false;
    },

    /**
     * Get legend src for visible layers
     *
     * @returns {Promise<void>}
     */
    getLegendSrc(change = false) {
      // skip if not active
      if ('tab' !== this.legend_position) { return }

      this.state.layerstrees.forEach(t => {
        let layers = this._traverseVisibleLayers(t.tree);
        this.showlegend = this.showlegend || layers.length > 0;
        t.tree.forEach(async tree => {
          try {
            if (
              change && (
                (tree.legendurls && 0 === tree.legendurls.length)
                || layers.some(l => l.legend.change)
                || ApplicationState.project.state.context_base_legend
              )
            ) {
              layers.filter(l => l.legend.change).forEach(l => l.legend.change = false);
            }
            tree.legendurls = await this._getLegendSrc(layers);
          } catch (e) {
            console.warn(e);
          }
        });
      });
    },

    _traverseVisibleLayers(obj, _layers = []) {
      for (const layer of obj) {
        if (null !== layer.id && undefined !== layer.id && layer.visible && layer.geolayer && !layer.exclude_from_legend) {
          _layers.push(layer);
        }
        if (null !== layer.nodes && undefined !== layer.nodes) {
          this._traverseVisibleLayers(layer.nodes, _layers);
        }
      }
      return _layers;
    },

    /**
     * Get legend src for visible layers
     *
     * @returns {Promise<void>}
     */
    async _getLegendSrc(visiblelayers) {

      // reset layers url
      const legendurls = [];

      // filter geolayer
      const layers = visiblelayers.filter(l => l.geolayer);

      const http = { GET: {}, POST: {} };

      layers.forEach(layer => {
        const name         = http[(layer.source && layer.source.url) || layer.external ? 'GET' : layer.ows_method];
        const catalogLayer = getCatalogLayerById(layer.id);

        const url          = catalogLayer ? catalogLayer.getLegendUrl((window.initConfig.layout || {}).legend, {
          all:        !ApplicationState.project.state.context_base_legend, // true = dynamic legend
          format:     'image/png',
          categories: layer.categories
        }) : undefined;


        // no url is set
        if (undefined === catalogLayer) { return }

        if (layer.source && layer.source.url) {
          name[url] = [];
          return
        }

        // extract LEGEND_ON and LEGEND_OFF from prefix -> (in case of legend categories)
        let prefix = url.split('LAYER=')[0].split('LEGEND_ON=')[0].split('LEGEND_OFF=')[0];

        if (!name[prefix]) { name[prefix] = [] }

        name[prefix].unshift({
          layerName:  url.split('LAYER=')[1],
          style:      (Array.isArray(layer.styles) && layer.styles.find(style => style.current) || ({ name: false })).name,
          legend_on:  (url.split('LAYER=')[0].split('LEGEND_ON=')[1] || '').replace('&', ''),                         // remove eventually &
          legend_off: (url.split('LAYER=')[0].split('LEGEND_ON=')[0].split('LEGEND_OFF=')[1] || '').replace('&', ''), // remove eventually &
        });
      });

      for (const method in http) {
        for (const url in http[method]) {
          const obj = {
            loading : true,
            url     : null,
            error   : false
          };

          legendurls.push(obj);

          const params = {
            LAYERS     : [],
            STYLES     : [],
            LEGEND_ON  : [],
            LEGEND_OFF : []
          };

          (http[method][url] || []).reduce((_, layer) => {
              params.LAYERS.push(layer.layerName);
              params.STYLES.push(layer.style);
              if (layer.legend_on)  { params.LEGEND_ON.push(layer.legend_on); }
              if (layer.legend_off) { params.LEGEND_OFF.push(layer.legend_off); }
              return params;
            }, params);

          let url_params = [
            __('LAYERS=',     params.LAYERS.join(',')),
            __('STYLES=',     params.STYLES.join(',')),
            __('LEGEND_ON=',  params.LEGEND_ON.join(',')),
            __('LEGEND_OFF=', params.LEGEND_OFF.join(',')),
            __('filtertoken=', ApplicationState.tokens.filtertoken),
          ]
          .filter(p => p) // discard nullish parameters (without a value)
          .join('&');

          try {
            obj.url = 'GET' === method
              ? url + (http[method][url].length ? url_params : '')
              : URL.createObjectURL(await (await fetch(url.split('?')[0], {
                  method:  'POST',
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
                  // send encoded params
                  body: // new URLSearchParams(url.split('?')[1])
                    url
                      .split('?')[1]
                      .split('&')
                      .filter(p => p.split('=')[0]).map(p => `${p.split('=')[0]}=${encodeURIComponent(p.split('=')[1])}`)
                      .join('&')
                      + '&' + url_params
                })).blob());
          } catch(e) {
            console.warn(e);
            //set loading to false
            obj.loading = false;
          } 
        }
      }
      return legendurls;
    },

    /**
     * get map Theme_configuration
     */
    async getMapThemeFromThemeName(theme) {
      const project = ApplicationState.project;
      // get map theme configuration from map_themes project config
      const config = Object.values(project.state.map_themes).flat().find(c => theme === c.theme );
      if (config && undefined === config.layerstree) {
        try {
          const response = await XHR.get({ url: `${project.urls.map_themes}${theme}/` });
          if (response.result) {
            config.layerstree = response.data;
          }
        } catch(e) {
          console.warn('Error while retreiving map theme configuration', e);
        }
      }
      return config;
    },

    /**
     * ORIGINAL SOURCE: src/app/core/project/project.js@v3.10.2
     * 
     * Set properties (checked and visible) from view to layerstree
     * 
     * @param map_theme map theme name
     * @param layerstree // current layerstree of TOC
     * 
     * @since 3.11.0
     */
    async setLayersTreePropertiesFromMapTheme({ map_theme, layerstree }) {
      const project = ApplicationState.project;
      layerstree = undefined !== layerstree ? layerstree : project.state.layerstree;
      /** map theme config */
      const theme = await this.getMapThemeFromThemeName(map_theme);
      // create a chages need to apply map_theme changes to map and TOC
      const changes  = { layers: {} }; // key is the layer id and object has style, visibility change (Boolean)
      const promises = [];
      /**
       * Traverse current layerstree of TOC and get changes with the new one related to map_theme choose
       * @param mapThemeLayersTree // new mapLayerTree
       * @param layerstree // current layerstree
       */
      const groups = [];
      const traverse = (mapThemeLayersTree, layerstree, checked) => {
        mapThemeLayersTree
          .forEach((node, index) => {
            if (node.nodes) { // case of a group
              groups.push({
                node,
                group: layerstree[index]
              });
              traverse(node.nodes, layerstree[index].nodes, checked && node.checked);
            } else {
              // case of layer
              node.style = theme.styles[node.id]; // set style from map_theme
              if (layerstree[index].checked !== node.visible) {
                changes.layers[node.id] = {
                  visibility: true,
                  style:      false
                };
              }
              layerstree[index].checked = node.visible;
              // if it has a style settled
              if (node.style) {
                const promise = new Promise(resolve => {
                  const setCurrentStyleAndResolvePromise = async node => {
                    if (changes.layers[node.id] === undefined) changes.layers[node.id] = {
                      visibility: false,
                      style:      false
                    };
                    changes.layers[node.id].style = await project.getLayerById(node.id).changeCurrentStyle(node.style);
                    resolve();
                  };
                  if (project.getLayersStore()) { setCurrentStyleAndResolvePromise(node) }
                  else { (node => setTimeout(() => setCurrentStyleAndResolvePromise(node)))(node) }// case of starting project creation
                });
                promises.push(promise);
              }
            }
        });
      };
      traverse(theme.layerstree, layerstree);

      await Promise.allSettled(promises);

      // all groups checked after layer checked so is set checked but not visible
      groups.forEach(({ group, node: { checked, expanded }}) => {
        group.checked  = checked;
        group.expanded = expanded;
      });

      return changes // eventually, information about changes (for example style etc..)
    },

    /**
     * Change view
     *
     * @fires VM~layer-change-style
     */
    async changeMapTheme(map_theme) {
      GUI.closeContent();

      // change map theme
      this.state.layerstrees[0].checked = true;

      const changes = (await this.setLayersTreePropertiesFromMapTheme({
        map_theme,
        rootNode:   this.state.layerstrees[0],
        layerstree: this.state.layerstrees[0].tree[0].nodes
      })).layers;

      // get all layers with styles
      const layers  = Object.keys(changes).filter(id => changes[id].style);
      const styles  = (await this.getMapThemeFromThemeName(map_theme)).styles;

      // clear categories
      layers.forEach(id => {
        if (!changes[id].visible) {
          const layer = getCatalogLayerById(id);
          layer.clearCategories();
          layer.change();
        }
      });

      // apply styles on each layer
      layers.forEach(id => VM.$emit('layer-change-style', { layerId: id, style: styles[id] }));

    },

    onTabClick(e) {
      if (e.target.attributes['aria-controls']) {
        this.activeTab = e.target.attributes['aria-controls'].value;
      }
    },

    setBaseLayer(id) {
      this.currentBaseLayer = id;
      this.project.setBaseLayer(id);
      ApplicationState.baseLayerId = id;
    },

    getSrcBaseLayerImage(baseLayer) {
      let image = 'nobaselayer.png';
      switch (baseLayer && baseLayer.servertype || baseLayer) {
        case 'OSM':  image = 'osm.png';                                    break;
        case 'Bing': image = `bing${baseLayer.source.subtype}.png`;        break;
        case 'TMS':  image = baseLayer.icon ? baseLayer.icon : image;      break;
        case 'WMTS': image = baseLayer.icon ? baseLayer.icon : image;      break;
      }
      return (baseLayer || {}).icon ? image : `${GUI.getResourcesUrl()}images/${image}`;
    },

    /**
     * ORIGINAL SOURCE: src/app/gui/queryresults/queryresultsservice.js::removeFromSelection
     * 
     * Remove layer from queryresults selection
     *
     * @since 3.10.0
     */
    async onUnSelectionLayer(storeid, layer) {
      if (!layer) {
        return console.warn('undefined layer');;
      }

      const service  = GUI.getService('queryresults');
      const action   = layer.external && service.getActionLayerById({ layer, id: 'selection' });

      // PROJECT LAYER
      if (!layer.external && storeid) {
        await ApplicationState.catalog[storeid].getLayerById(layer.id).clearSelectionFids();
      }

      // EXTERNAL LAYER
      if (layer.external) {
        layer.selection.active = false;
        layer.selection.features.forEach((feature, i) => {
          // skip when ..
          if (!feature.selection.selected) {
            return;
          }
          feature.selection.selected = false;
          if (action) {
            action.state.toggled[i] = false;
          }
          GUI.getService('map').setSelectionFeatures('remove', { feature });
        });
      }

      //@since 4.0.4 Need to set to false eventually features of layer in queryresults service
      if (!layer.external) {
        (service.state.layers.find(l => layer.id === l.id)?.features || []).forEach(f => f.selection.selected = false);
      }
    },

    /**
     * @TODO add description
     *
     * @since 3.10.0
     */
    async onActiveFilterTokenLayer(storeid, layerstree) {
      layerstree.filter.active = await ApplicationState.catalog[storeid].getLayerById(layerstree.id).toggleFilterToken();
    },

    /**
     * Handle visibilty change on legend item
     *
     * @fires MapService~cataloglayervisible
     *
     * @since 3.10.0
     */
    onTreeNodeVisible(layer) {
      GUI.getService('map').emit('cataloglayervisible', layer);
    },

    /**
     * Handle legend item select (single mouse click ?)
     *
     * @fires MapService~cataloglayerselected
     *
     * @since 3.10.0
     */
    onTreeNodeSelected(node) {
      GUI.getService('map').selectLayer(node.id);
    },

    /**
     * @since 3.11.0
     */
    showaddLayerModal() {
      if (window.innerWidth < 767) {
        GUI.hideSidebar();
      }
      $('#modal-addlayer').modal('show');
    },

    /**
     * @since 3.11.0
     */
    openChangeMapMenu() {
      if (window.innerWidth < 767) {
        GUI.hideSidebar();
      }
      $('#modal-changemap').modal('show');
    },
    

  },

  watch: {

    /**
     * Listen to external wms change. If remove all layers need to set active the project or default tab
     */
    'state.external.wms'(newlayers, oldlayers) {
      if (oldlayers && 0 === newlayers.length) {
        this.activeTab = this.project.state.catalog_tab || 'layers';
      }
    },

    project: {
      async handler(project) {
        const activeTab = project.state.catalog_tab || 'layers';
        this.loading    = 'baselayers' === activeTab;
        await this.$nextTick();
        setTimeout(() => {
          this.loading   = false;
          this.activeTab = activeTab;
        }, ('baselayers' === activeTab) ? 500 : 0)
      },
      immediate: false
    },

    activeTab(activeTab, oldTab) {
      if ('legend' === activeTab) {
        this.getLegendSrc(true);
      }
      if (this.$el) {
        this.$el.parentElement.classList.remove(`tab-${oldTab}`);
        this.$el.parentElement.classList.add(`tab-${activeTab}`);
      }
    },

  },

  /**
   * @listens VM~unselectionlayer
   * @listens VM~activefiltertokenlayer
   * @listens VM~treenodevisible
   * @listens VM~treenodeselected
   */
  created() {
    VM.$on('unselectionlayer',                       this.onUnSelectionLayer);
    VM.$on('activefiltertokenlayer',                 this.onActiveFilterTokenLayer);
    VM.$on('treenodevisible',                        this.onTreeNodeVisible);
    VM.$on('treenodeselected',                       this.onTreeNodeSelected);
    VM.$on('layer-change-style',                     this.getLegendSrc);
  },

  beforeMount() {
    this.currentBaseLayer = this.project.state.initbaselayer;
  },

  async mounted() {
    await this.$nextTick();
    // in case of dynamic legend
    if (ApplicationState.project.state.context_base_legend) {
      GUI.getService('map').on('change-map-legend-params', () => { this.getLegendSrc(); });
    } else {
      this.getLegendSrc();
    }
  },

};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabbable-panel catalog"},[_c('div',{staticClass:"tabbable-line"},[_c('ul',{staticClass:"nav nav-tabs catalalog-nav-tabs",attrs:{"role":"tablist"},on:{"!click":function($event){return _vm.onTabClick.apply(null, arguments)}}},[(_vm.hasLayers)?_c('li',{class:{ active: ('layers' === _vm.activeTab) },attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('data'),expression:"'data'"}],attrs:{"href":"#layers","aria-controls":"layers","role":"tab","data-toggle":"tab"}})]):_vm._e(),_vm._v(" "),(_vm.state.external.wms.length)?_c('li',{class:{ active: ('externalwms' === _vm.activeTab) },attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('externalwms'),expression:"'externalwms'"}],attrs:{"href":"#externalwms","aria-controls":"externalwms","role":"tab","data-toggle":"tab"}})]):_vm._e(),_vm._v(" "),(_vm.hasBaseLayers)?_c('li',{class:{ active: ('baselayers' === _vm.activeTab) },attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('baselayers'),expression:"'baselayers'"}],attrs:{"href":"#baselayers","aria-controls":"baselayers","role":"tab","data-toggle":"tab"}})]):_vm._e(),_vm._v(" "),('tab' === _vm.legend_position && _vm.showlegend)?_c('li',{class:{ active: ('legend' === _vm.activeTab) },attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('legend'),expression:"'legend'"}],attrs:{"href":"#legend","aria-controls":"legend","role":"tab","data-toggle":"tab","data-i18n":"legend"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-content catalog-tab-content"},[_c('bar-loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_c('div',{staticClass:"tab-pane",class:{ active: ('layers' === _vm.activeTab) },attrs:{"id":"layers","role":"tabpanel"}},[_c('div',{staticStyle:{"margin":"2px"},attrs:{"id":"g3w-catalog-toc-layers-toolbar"}},[_c('catalog-change-map-themes',{key:_vm.project.state.gid,attrs:{"map_themes":_vm.project.state.map_themes,"layerstrees":_vm.state.layerstrees},on:{"change-map-theme":_vm.changeMapTheme}})],1),_vm._v(" "),_vm._l((_vm.state.layerstrees),function(root){return _c('ul',{key:root.storeid,staticClass:"tree-root root project-root"},_vm._l((root.tree),function(tree){return _c('catalog-tristate-tree',{key:tree.id,staticClass:"item",attrs:{"layerstree":tree,"parentFolder":false,"root":true,"legendplace":_vm.legend_position,"parent_mutually_exclusive":false,"storeid":root.storeid}})}),1)}),_vm._v(" "),(_vm.state.external.vector.length)?_c('ul',{staticClass:"g3w-external_layers-group"},_vm._l((_vm.state.external.vector),function(vector){return _c('catalog-tristate-tree',{key:vector.id,staticClass:"item",attrs:{"externallayers":_vm.state.external.vector,"layerstree":vector}})}),1):_vm._e(),_vm._v(" "),_vm._l((_vm.state.layersgroups),function(group){return _c('ul',{staticClass:"g3w-catalog-layers-group"},[_c('div',[_c('h4',[_vm._v(_vm._s(group.title))]),_vm._v(" "),_vm._l((group.nodes),function(node){return _c('catalog-tristate-tree',{staticClass:"item",attrs:{"layerstree":node}})})],2)])})],2),_vm._v(" "),(_vm.state.external.wms.length)?_c('div',{staticClass:"tab-pane",class:{ active: ('externalwms' === _vm.activeTab) },attrs:{"id":"externalwms","role":"tabpanel"}},[_c('ul',{staticClass:"g3w-external_wms_layers-group"},_vm._l((_vm.state.external.wms),function(wms){return _c('catalog-tristate-tree',{key:wms.id,staticClass:"item",attrs:{"externallayers":_vm.state.external.wms,"layerstree":wms}})}),1)]):_vm._e(),_vm._v(" "),(_vm.hasBaseLayers)?_c('div',{staticClass:"tab-pane baselayers",class:{ active: ('baselayers' === _vm.activeTab || !_vm.hasLayers) },attrs:{"id":"baselayers","role":"tabpanel"}},[_c('ul',{class:{'mobile': _vm.isMobile()},style:({ gridTemplateColumns: ("repeat(auto-fill, minmax(" + (_vm.baselayers.length > 4 ? 80 : 120) + "px, 1fr))") }),attrs:{"id":"baselayers-content"}},[_vm._l((_vm.baselayers),function(base){return (!base.fixed)?_c('li',{key:base.title},[_c('img',{staticClass:"img-responsive img-thumbnail baselayer",style:({ opacity: _vm.currentBaseLayer === base.id ? 1 : 0.5, height: _vm.baselayers.length > 4 ? '108px' : null  }),attrs:{"src":_vm.getSrcBaseLayerImage(base)},on:{"click":function($event){$event.stopPropagation();return _vm.setBaseLayer(base.id)}}}),_vm._v(" "),_c('div',{staticClass:"baseselayer-text text-center g3w-long-text"},[_vm._v(_vm._s(base.title))])]):_vm._e()}),_vm._v(" "),_c('li',{on:{"click":function($event){$event.stopPropagation();return _vm.setBaseLayer(null)}}},[_c('img',{staticClass:"img-responsive img-thumbnail baselayer",style:({ opacity: _vm.currentBaseLayer === null ? 1 : 0.5 }),attrs:{"src":_vm.getSrcBaseLayerImage(null)}}),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:('nobaselayer'),expression:"'nobaselayer'"}],staticClass:"baseselayer-text text-center g3w-long-text"})])],2)]):_vm._e(),_vm._v(" "),_vm._l((_vm.state.layerstrees),function(tree){return ('tab' === _vm.legend_position && 'legend' === _vm.activeTab)?_c('div',{key:tree.id,staticClass:"tab-pane",class:{ active: 'legend' === _vm.activeTab },style:({ backgroundColor: _vm.backgroundLegend }),attrs:{"role":"tabpanel","id":"legend"}},_vm._l((tree.tree),function(t){return _c('div',{staticClass:"legend-item"},_vm._l((t.legendurls),function(url){return _c('figure',{key:url.url},[_c('bar-loader',{attrs:{"loading":url.loading}}),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(!url.loading && !url.error),expression:"!url.loading && !url.error"}],attrs:{"src":url.url,"alt":""},on:{"error":function($event){return _vm.onLegendError(url)},"load":function($event){return _vm.onLegendLoad(url)}}}),_vm._v(" "),_c('divider')],1)}),0)}),0):_vm._e()})],2)]),_vm._v(" "),(_vm.hasRelatedMaps || 'legend' !== _vm.activeTab)?_c('div',{staticStyle:{"position":"sticky","bottom":"0","background-color":"var(--bgcolor)","display":"flex","text-align":"center","line-height":"48px","color":"#fff","border-top":"2px solid var(--skin-color)","margin-top":"12px","justify-content":"space-around"}},[('legend' !== _vm.activeTab)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.showaddLayerModal.apply(null, arguments)}}},[_c('i',{class:_vm.$fa('layers')}),_vm._v(" "),_c('b',{directives:[{name:"t",rawName:"v-t",value:('Add Layer'),expression:"'Add Layer'"}]})]):_vm._e(),_vm._v(" "),(_vm.hasRelatedMaps && 'legend' !== _vm.activeTab && !_vm.iframe)?_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.stopPropagation();return _vm.openChangeMapMenu.apply(null, arguments)}}},[_c('i',{class:_vm.$fa('refresh')}),_vm._v(" "),_c('b',{directives:[{name:"t",rawName:"v-t",value:('changemap'),expression:"'changemap'"}]})]):_vm._e()]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-13497690_0", { source: ".tabbable-line>.nav-tabs>li.active{border-bottom:4px solid var(--skin-color)}.catalog #legend div.selected,.catalog .tree-item.selected{background-color:var(--skin-color)}.catalog-context-menu li.title{border-bottom-color:var(--skin-color)!important}.skin-blue .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #6abbea}.skin-blue .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #6abbea}.skin-blue .tabbable-line.tabs-below>.nav-tabs>li.active{border-top:4px solid #f3565d}.skin-green .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #00ff8e}.skin-green .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #00ff8e}.skin-green .tabbable-line.tabs-below>.nav-tabs>li.active{border-top:4px solid #f3565d}.skin-purple .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #a19dff}.skin-purple .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #a19dff}.skin-purple .tabbable-line.tabs-below>.nav-tabs>li.active{border-top:4px solid #f3565d}.skin-red .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #ff5542}.skin-red .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #ff5542}.skin-red .tabbable-line.tabs-below>.nav-tabs>li.active{border-top:4px solid #ff5542}.skin-yellow .tabbable-line>.nav-tabs>li:is(.open,:hover){border-bottom:4px solid #ffde0d}.skin-yellow .tabbable-line.tabs-below>.nav-tabs>li:hover{border-top:4px solid #ffde0d}.skin-yellow .tabbable-line.tabs-below>.nav-tabs>li.active{border-top:4px solid #ffdf12}.tabbable-panel{padding:10px}.tabbable-line>.nav-tabs{border:none;margin:0}.tabbable-line .nav-tabs ul li{color:#fff}.tabbable-line>.nav-tabs>li{margin-right:2px;border-bottom:4px solid hsl(from var(--bgcolor) h s calc(l - 2))}.tabbable-line>.nav-tabs>li>a{border:0;margin-right:0;color:#fff}.tabbable-line>.nav-tabs>li>a>i{color:#a6a6a6}.tabbable-line>.nav-tabs>li:is(.open,:hover)>a{border:0;background:0 0!important}.tabbable-line>.nav-tabs>li:is(.open,:hover)>a>i{color:#a6a6a6}.tabbable-line>.nav-tabs>li:is(.open,:hover) .dropdown-menu{margin-top:0}.tabbable-line>.nav-tabs>li.active{position:relative;font-weight:700}.tabbable-line>.nav-tabs>li.active>a{border:0;color:#fff;background-color:hsl(from var(--bgcolor) h s calc(l + 4))}.tabbable-line>.nav-tabs>li.active>a>i{color:#fff}.tabbable-line>.tab-content.catalog-tab-content{margin-top:-3px;border:0;color:#fff;padding:5px 0 0 0}.portlet .tabbable-line>.tab-content{padding-bottom:0}.tabbable-line.tabs-below>.nav-tabs>li{border-top:4px solid transparent}.tabbable-line.tabs-below>.nav-tabs>li>a{margin-top:0}.tabbable-line.tabs-below>.nav-tabs>li:hover{border-bottom:0;color:#fff}.tabbable-line.tabs-below>.nav-tabs>li.active{margin-bottom:-2px;border-bottom:0}.tabbable-line.tabs-below>.tab-content{margin-top:-10px;border-top:0;border-bottom:1px solid #eee;padding-bottom:15px}.nav-tabs>li.active>a,.nav-tabs>li.active>a:is(:focus,:hover){color:#fff}.catalog>.title{padding:10px;font-weight:700}.catalog ul{line-height:1.75em;list-style-type:none}.catalog #legend div.selected ul.layer-categories,.catalog .tree-item.selected ul.layer-categories{background-color:var(--bgcolor)}.catalog #legend div div.tree-node-title,.catalog .tree-item div.tree-node-title{padding-left:3px;cursor:pointer;width:80%;display:inline-flex;justify-content:space-between;user-select:none}.catalog #legend div div.tree-node-title.disabled,.catalog .tree-item div.tree-node-title.disabled{color:#999}.catalog #legend div div.tree-node-title .selection-filter-icon,.catalog .tree-item div.tree-node-title .selection-filter-icon{box-shadow:rgba(0,0,0,.3) 0 2px 5px;padding:5px;border-radius:3px;margin:0 3px;font-weight:700;color:#fff!important}.catalog #legend div div.tree-node-title .selection-filter-icon.active,.catalog .tree-item div.tree-node-title .selection-filter-icon.active{box-shadow:none;background-color:#384247}.catalog .tree-item{cursor:pointer;margin-bottom:3px}.catalog .tree-item.disabled>span{color:#999}.catalog .root{padding:2px 1px 1px 5px}.catalog .root .tree-item.group{padding-left:1px}.catalog .root.fa-chevron-right{padding-right:5px;padding-left:0}.catalog .root-categories.fa-chevron-right{padding-right:7px}.catalog .root-categories.fa-chevron-down{padding-right:3px}.bold{font-weight:700;color:#fff}.highlightlayer{border-bottom:2px dashed;border-color:#ffb516}.catalog{padding:3px}.catalog .tree-root{padding-left:0}.catalog .tree-root li>.root{padding-left:5px}.catalog .tree-root li.tree-item ul.tree-content-items.root{padding-left:18px}.catalog .tree-root li.tree-item ul.tree-content-items.root>.tree-item.group{padding-left:1px!important}.catalog .tree-root li.tree-item ul.tree-content-items{padding-left:17px;padding-top:2px}.g3w-lendplace-toc{padding-left:23px}.g3w-lendplace-toc.group{padding-left:17px}.g3w-lendplace-toc.root{padding-left:18px}.g3w-lendplace-toc.root>li.itemmarginbottom{margin-left:-13px}.g3w-lendplace-toc.root>li.itemmarginbottom div.layer-legend{padding-left:56px}.g3w-lendplace-toc.root>li.itemmarginbottom>span.child{padding-left:18px!important}.catalog .tree-root span.root.collapse-expande-collapse-icon{width:19px}.catalog .tree-root span.root.collapse-expande-collapse-icon.project-root{width:17px}.catalog .tree-root span.collapse-expande-collapse-icon{width:10px}.catalog span.legend-collapse-expande-collapse-icon{font-size:1.2em}.catalog .child-categories{padding:5px 3px 1px 12px}.catalog .layer-legend{padding:3px 0 0 35px;background-color:var(--bgcolor)}.catalog .catalalog-nav-tabs{display:flex;flex:1 1 0}.catalog .catalalog-nav-tabs>li{font-size:1em;white-space:initial;display:flex;flex:1 1 0;align-items:stretch}.catalog .catalalog-nav-tabs>li a{padding:10px 0;text-align:center;height:100%;width:100%}.catalog .tree{color:#fff}.catalog .tree.disabled{color:#999;cursor:not-allowed}.catalog .g3w-external_wms_layers-group{padding:5px}.catalog .baselayers .radio{margin:0}#baselayers-content{display:grid;justify-content:center;grid-gap:5px;padding:0;margin:5px}#baselayers-content.mobile{grid-template-columns:repeat(auto-fill,minmax(80px,110px))}#baselayers-content .baseselayer-text{white-space:pre-line;font-weight:700}#baselayers-content .baselayer{cursor:pointer}#baselayers-content .baselayer .baselayer-name{font-weight:700;white-space:pre-line;text-align:center}#catalog #layers ul.g3w-external_layers-group{padding-left:0!important}#catalog #layers ul.g3w-external_layers-group li{padding-left:2px!important}#catalog #layers .sidebar-menu>li>a{border:0}#catalog>a{display:none!important}#catalog .tree-item>.toggle-context-menu{opacity:0;position:absolute;inset:0 4px auto auto;color:#fff;padding:4px 8px;border:1px solid;border-radius:3px}#catalog .tree-item:not(.group):hover>.toggle-context-menu{opacity:1}", map: undefined, media: undefined })
,inject("data-v-13497690_1", { source: "#legend .divider[data-v-13497690]{display:block;position:relative;padding:0;margin:8px auto;height:0;width:100%;max-height:0;font-size:1px;line-height:0;clear:both;border:none}.legend-item[data-v-13497690]{width:100%;position:relative}.g3w-catalog-layers-group>div[data-v-13497690]{border:1px solid #ffffff33;margin:5px}.g3w-catalog-layers-group>div>h4[data-v-13497690]{margin:5px;font-weight:700}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-13497690"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Catalog.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__